import { createModel } from "hox";
import useStorageState from "../hooks/useStorageState";
import { customerService, IVRMCustomerDetail } from "@/views/base/customerFiles/customer/baseCustomerService";
import { IVRMSupplierDetail, supplierService } from "@/views/base/supplier/supplierService";
import { IVRMWarehouseDetail } from "@/views/base/warehouse/warehouseTypes";
import { IVehicleDetail } from "@/views/base/customerFiles/vehicle/vehicleType";
import { IPgProps, ISelectOptions } from "@/types/ScmTypes";
import { beService } from "@/views/organization/entity/entityService";
import { shopService } from "@/views/organization/shop/shopService";
import { sourceAppOrBranch } from "@/types/VrmSaDictEnums";
import { ITechnicianDetail } from "@/views/base/technician/technicianType";
import appService from "@/views/account/appService";
import { warehouseService } from "@/views/base/warehouse/warehouseService";
import { technicianService } from "@/views/base/technician/technicianService";
import { IVRMSettleTypeEnum } from "@/types/FmsDs";
import { UserTypeEnum } from "@/types/FmsEnums";
import { accountService } from "@/views/account/AccountService";
import { billService } from "@/views/bill/BillService";
import { message } from "antd";
import { acctUnitService, ISCMAcctUnitDetail } from "@/views/base/acctUnit/acctUnitService";
import { ISelectOption } from "@/components/YhFormBox/Types";
import { useState } from "react";

export type RoleType = {
    id: number,
    name: String,
};
export type UserType = {
    id: number,
    username: string,
    password: String,
    token: string,
    shopCode: string,
    loginType?: "account" | "token",
    roles: string[],
    [key: string]: any
}
export type ShopAndOrgType = {
    shopId: string,
    shopName: string,
    shopCode: string,
    orgCode: String,
    orgName: string
}
type GlobalModelType = {
    user: UserType,
    setUser: (e: UserType) => void,
    resetUser: () => void,
    toggleMenu: () => void,
    cm: CmType,
    resetCm: () => void,

    beShopDs: ISelectOptions[],
    setBeShopDs: (value: ISelectOptions[] | ((previousState?: ISelectOptions[] | undefined) => ISelectOptions[])) => void

    accUnitDs: ISCMAcctUnitDetail[],
    accUnitDataAll: () => void,
    setAccUnitDs: (origin: ISCMAcctUnitDetail[]) => void
    fetchFmsShopList: (value: string) => Promise<ISelectOption[]>,

    [key: string]: any,
};

export type LoadingType = { loadingVisible: boolean, txt: string };


const initUserState = {
    id: 0,
    username: "",
    password: "",
    token: "",
    shopCode: "",
    roles: [],
}
const initShopAndOrg = {
    shopId: "",
    shopName: "",
    orgCode: "",
    orgName: "",
    shopCode: ""

}
type CmType = {
    collapsed: boolean
}
const initCmState = {
    collapsed: false
}
//返回列表韦options的格式
export const transOptions = (list: any[]) => {
    return list.length != 0 ? list.map(item => ({ label: item.name, value: item.code, disabled: item.enable === 0 ? true : false })) : []
}
export const getFindItem = (code: string, list: any[]) => {
    return list.find(item => item.code === code)
}
//返回列表韦options的格式
export const vehicleOption = (list: any[]) => {
    return list.length != 0 ? list.map(item => ({ label: item.label, value: item.value, disabled: item.enable === 0 ? true : false })) : []
}
//返回列表韦options的格式
export const vinOption = (list: any[]) => {
    return list.length != 0 ? list.filter(filItem => filItem.vin).map(item => ({ label: item.vin, value: item.vin, disabled: item.enable === 0 ? true : false })) : []
}
// 返回对应车辆牌照的车辆所有信息
export const getVehicleItem = (licensePlate: string, list: any[]) => {
    return list.find(item => item.licensePlate === licensePlate)
}
// 返回对应vin的车辆所有信息
export const getVinItem = (vin: string, list: any[]) => {
    return list.find(item => item.vin === vin)
}
function useModel(): GlobalModelType {


    const [user, setUser, resetUser] = useStorageState<UserType>('user', initUserState);
    const [shopAndOrg, setShopAndOrg, resetShopAndOrg] = useStorageState<ShopAndOrgType>('shopAndOrgNews', initShopAndOrg);
    //客户数据
    const [CustomerData, setCustomerData, clearCustomerData] = useStorageState<IVRMCustomerDetail[]>("customerList", [])
    //供应商数据
    const [supplieAllList, setsupplieAllList, resetsupplieAllList] = useStorageState<IVRMSupplierDetail[]>("supplieAllList", []);
    //仓库数据
    const [warehouseList, setWarehouseList, resetWarehouseList] = useStorageState<IVRMWarehouseDetail[]>("warehouseList", []);
    //车辆数据
    const [vehicleData, setVehicleData, clearVehicleData] = useStorageState<IVehicleDetail[]>("vehicleList", [])

    const [cm, setCm, resetCm] = useStorageState<CmType>('cm', initCmState);
    //所有站点
    const [shopDs, setShopDs] = useStorageState<ISelectOptions[]>("vrm.shopDs", []);
    //所有站点
    const [allShopDs, setAllShopDs] = useStorageState<ISelectOptions[]>("vrm.AllShopDs", []);
    //所有经营实体
    const [beDs, setBeDs] = useStorageState<ISelectOptions[]>("vrm.beDs", []);
    //主数据下所有经营实体
    const [mdmBeDs, setMdmBeDs] = useStorageState<ISelectOptions[]>("mdm.beDs", []);
    //主数据下所有站点
    const [mdmShopDs, setMdmShopDs] = useStorageState<ISelectOptions[]>("mdm.shopDs", []);
    //对应站点的经营实体
    const [beShopDs, setBeShopDs] = useStorageState<ISelectOptions[]>("vrm.beShopDs", []);
    //所有内部核算单位
    const [accUnitDs, setAccUnitDs] = useStorageState<ISCMAcctUnitDetail[]>("scm.acctUnit", [])
    //所有App系统分支
    const [appDs, setAppDs] = useStorageState<ISelectOptions[]>("fms.appDs", []);
    //用户所有菜单权限
    const [menuAuth, setMenuAuth] = useStorageState<string[]>("user.menus", []);
    //用户所有资源权限
    const [resourceAuth, setResourceAuth] = useStorageState<string[]>("user.resource", []);
    //维修技师数据
    const [technicianData, setTechniciankData] = useStorageState<ITechnicianDetail[]>("technicianList", [])
    //初始页数
    const initPage = { pageSize: 999999, pageNum: 1 };
    //全局loading
    const [loadingInfo, setLoadingInfo] = useState<LoadingType>({ loadingVisible: false, txt: "" });
    const [changePassVisible, setChangePassVisible] = useState(false);
    //站点缓存
    const shopLoadDataAll = async () => {
        // let { retData } = await shopService.page({ page: initPage, sourceApp: sourceAppOrBranch.sourceApp });
        // const { records } = retData;
        // let shopOptions = records.map(item => ({
        //     key: item.id,
        //     label: item.name,
        //     value: item.id,
        //     code: item.code
        // }));
        // setShopDs(shopOptions);
    }
    //主数据所有站点缓存
    const mdShopLoadDataAll = async () => {
        // let { retData } = await shopService.pageFms({ page: initPage, sourceApp: "fms", status: 0 });
        // const { records } = retData;
        // let shopOptions = records.map(item => ({
        //     key: item.id,
        //     label: item.name,
        //     value: item.id,
        //     code: item.code
        // }));
        // setMdmShopDs(shopOptions);
        setMdmShopDs([]);
    }
    //初始经营实体缓存
    const beLoadDataAll = async () => {
        const searchParams = {
            // ...defaultMdCmParam,
            // branch: "",
            "sourceApp": "vrm",
            page: {
                pageSize: 999999,
                pageNum: 1,
            }
        }
        let { retData } = await beService.page(searchParams);
        const { records } = retData;
        setBeDs(records.map(item => ({
            id: item.key as string,
            label: item.name ?? "",
            value: item.code ?? ""
        })));
    }
    //初始主数据所有经营实体缓存
    const mdmBeLoadDataAll = async () => {
        // const searchParams = {
        //     // ...defaultMdCmParam,
        //     // branch: "",
        //     "sourceApp": "fms",
        //     page: {
        //         pageSize: 999999,
        //         pageNum: 1,
        //     }
        // }
        // let { retData } = await beService.fmsPage(searchParams);
        // const { records } = retData;
        // setMdmBeDs(records.map(item => ({
        //     id: item.key as string,
        //     label: item.name ?? "",
        //     value: item.code ?? ""
        // })));
        setMdmBeDs([])
    }
    //初始应用分支缓存
    const appLoadDataAll = async () => {
        // let { retData } = await appService.find({});
        // let appOptios = retData.map(item => ({
        //     label: item.name ?? "",
        //     value: item.code ?? "",
        // }));
        setAppDs([]);
    }

    const toggleMenu = () => {
        setCm({
            ...cm,
            collapsed: !cm.collapsed
        })
    }
    //初始所有仓库
    const loadWarehouseAllData = async (shopId: string) => {
        const params = {
            pageSize: 10000,
            pageNum: 1,
            shopId,
        }
        let { retData } = await warehouseService.page(params);
        const { records, ...pg } = retData;
        const newRecords = records.map(item => ({
            ...item,
            // code: item.id,
            // codes: item.code
        }))
        setWarehouseList(newRecords)
    }
    //初始所有客户
    const loadCustomerAllData = async (shopId: string) => {
        const params = {
            shopId,
            ...sourceAppOrBranch,
            pageSize: 100000,
            pageNum: 1
        }
        let { retData } = await customerService.totalPage(params);
        setCustomerData(retData)
    }
    //初始所有供应商
    const loadSupplierAllData = async (shopId: string) => {
        const params = {
            pageSize: 10000,
            pageNum: 1,
            shopId,
        }
        let { retData } = await supplierService.page(params);
        const { records, ...pg } = retData;
        // setsupplieAllList(records.filter(item => item.userCode))
        setsupplieAllList(records)
    }

    //初始所有维修技师
    const loadTechnician = async (shopId: string) => {
        const params = {
            shopId,
            ...sourceAppOrBranch,
            pageSize: 10000,
            pageNum: 1
        }
        let { retData } = await technicianService.page(params);
        const { records, ...pg } = retData;
        let newRecords = records.map(item => {
            return {
                ...item,
                code: item.technicianCode
            }
        })
        setTechniciankData(newRecords)
    }
    //根据结算方 查回对应的账户名称，可用额度，是否有账单，客户名称 并返回
    const getSettlementParty = async (res: any) => {
        let { settlementPartyCode, customerName, customerCode, payType, settlementsettlementPartyParams, bentityCode } = res
        let { shopCode, shopName, shopId } = shopAndOrg;
        let accountName = "", availableAmount = 0, isBill = false, accountCustomerName = "";
        if (settlementPartyCode === "settle-party.internal") {//这里为部门内部结算时，查询销售实体为客户的接口换取id
            await customerService.page({ name: shopName, pageSize: 15, pageNum: 1, shopId }).then(async (res) => {
                let { records } = res.retData
                // console.log(records)
                // debugger;
                if (records.length) {
                    let { code, name } = records[0]
                    await getCustomerBillAndAccount(code as string, payType, bentityCode).then((res: any) => {
                        accountName = res.accountName;
                        availableAmount = res.availableAmount;
                        isBill = res.isBill
                    })
                    accountCustomerName = name as string
                } else {
                    // message.warning(`该结算方为部门内部费用时，无维护对应为${shopName}客户`)
                    message.warning(`该“结算方”为“部门内部费用”时，没有找到“${shopName}”的客户。
                    请对该客户维护后，进行操作！`)
                }
            })
            // } else if (settlementPartyCode?.indexOf("man-cn") !== -1 ||
            //     settlementPartyCode?.indexOf("scania-cn") !== -1 ||
            //     settlementPartyCode?.indexOf("sdec") !== -1 ||
            //     settlementPartyCode?.indexOf("hande") !== -1 ||
            //     settlementPartyCode?.indexOf("xcqc") !== -1 ||
            //     settlementPartyCode?.indexOf("weichai") !== -1 ||
            //     settlementPartyCode?.indexOf("fast") !== -1 ||
            //     settlementPartyCode?.indexOf("saic-iveco-hy") !== -1 ||
            //     settlementPartyCode?.indexOf("voith") !== -1
            //     ) {
        } else if (!(settlementPartyCode === "settle-party.internal" || settlementPartyCode === "settle-party.self-pay" || settlementPartyCode === "settle-party.dabaomaintenance")) {
            let { value: customerCode, name } = settlementsettlementPartyParams
            await getCustomerBillAndAccount(customerCode as string, payType, bentityCode).then((res: any) => {
                accountName = res.accountName;
                availableAmount = res.availableAmount;
                isBill = res.isBill
            })
            accountCustomerName = name as string
        } else {
            await getCustomerBillAndAccount(customerCode as string, payType, bentityCode).then((res: any) => {
                accountName = res.accountName;
                availableAmount = res.availableAmount;
                isBill = res.isBill
            })
            accountCustomerName = customerName as string
        }
        return { accountName, availableAmount, isBill, accountCustomerName }
    }
    const getCustomerBillAndAccount = async (partnerCode: string, payType: IVRMSettleTypeEnum, bentityCode: string) => {//参数partnerCode为客户编码 payType为结算类型
        let { shopCode } = shopAndOrg
        //根据结算类型过滤出对应的账户类型
        let accountCode = payType === IVRMSettleTypeEnum.SETTLE_CREDIT ? "account-type.credit" : IVRMSettleTypeEnum.SETTLE_MONTHLY ? "account-type.credit-month" : ""
        let billParams = {
            page: { pageSize: -1, pageNum: 1 },
            shopCode,
            beCode: bentityCode,
            partnerTypeCode: UserTypeEnum.CUSTOMER,
            partnerCode,
            status: 0,
        }//账单搜索参数
        let accountParams = {
            shopCode,
            partnerCode,
            beCode: bentityCode,
        }//账户搜索参数
        let { retData: accountData } = await accountService.accountFind(accountParams);
        let { retData: { records: billData } } = await billService.page(billParams);
        let newAccount = accountData.find(item => item.accountTypeCode == accountCode)
        let newBill = billData.filter(item => item.accountTypeCode == accountCode)
        return {
            accountName: newAccount?.name,
            availableAmount: newAccount?.availableAmount ?? 0,
            isBill: newBill.length > 0
        }
    }
    //所有内部核算单位接口
    const accUnitDataAll = async () => {
        // const searchParams = {
        //     shopId: user.shopId,
        //     pageSize: -1,
        //     pageNum: 1,
        // }
        // let { retData } = await acctUnitService.page(searchParams);
        // const { records, ...pg } = retData;
        // setAccUnitDs(records)
        setAccUnitDs([])
    }
    //实时查询财务的站点
    const fetchFmsShopList = async (value: string) => {
        let { retData } = await shopService.page({ page: initPage, sourceApp: sourceAppOrBranch.sourceApp });
        const { records } = retData;
        let shopOptions = records.filter((list) => list.status == 0).map(item => ({
            key: item.id,
            label: item.name,
            value: item.code,
            code: item.code,
            id: item.id,
        }));
        return shopOptions
    }
    //所有缓存加载与重置
    const requestCatchAll = (shopId: string = shopAndOrg.shopId) => {
        loadWarehouseAllData(shopId);
        loadCustomerAllData(shopId);
        loadSupplierAllData(shopId);
        loadTechnician(shopId);
        appLoadDataAll();
        beLoadDataAll();
        mdmBeLoadDataAll();
        accUnitDataAll();
        mdShopLoadDataAll();
    }
    return {
        user,
        setUser,
        resetUser,
        toggleMenu,
        cm,
        resetCm,
        shopAndOrg,
        setShopAndOrg,
        resetShopAndOrg,
        CustomerData,
        setCustomerData,
        clearCustomerData,
        supplieAllList,
        setsupplieAllList,
        resetsupplieAllList,
        warehouseList,
        setWarehouseList,
        resetWarehouseList,
        vehicleData,
        setVehicleData,
        clearVehicleData,
        beLoadDataAll,
        beDs,
        setBeDs,
        beShopDs,
        setBeShopDs,
        shopLoadDataAll,
        technicianData, setTechniciankData,
        menuAuth, setMenuAuth,
        resourceAuth, setResourceAuth,
        shopDs, setShopDs,
        allShopDs, setAllShopDs,
        appDs, setAppDs,
        appLoadDataAll,
        loadWarehouseAllData,
        loadCustomerAllData,
        loadSupplierAllData,
        loadTechnician,
        requestCatchAll,
        getCustomerBillAndAccount,
        getSettlementParty,
        accUnitDataAll,
        accUnitDs, setAccUnitDs,
        fetchFmsShopList,
        mdmBeLoadDataAll,
        mdmBeDs, setMdmBeDs,
        mdmShopDs, setMdmShopDs,
        loadingInfo, setLoadingInfo,
        changePassVisible, setChangePassVisible,
    };
}

export const useGlobalModel = createModel(useModel)
export default useGlobalModel;
